var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50083 13.9397V13.7179C3.53295 13.0616 3.7406 12.4257 4.10236 11.8758C4.7045 11.2152 5.1167 10.4057 5.29571 9.53224C5.29571 8.85714 5.29571 8.17239 5.35393 7.49728C5.65469 4.24714 8.82728 2 11.9611 2H12.0387C15.1725 2 18.345 4.24714 18.6555 7.49728C18.7137 8.17239 18.6555 8.85714 18.704 9.53224C18.8854 10.4078 19.2972 11.2198 19.8974 11.8855C20.2618 12.4305 20.4698 13.0641 20.4989 13.7179V13.9301C20.5206 14.8118 20.2208 15.6715 19.6548 16.3508C18.907 17.145 17.8921 17.6391 16.8024 17.7396C13.607 18.0868 10.383 18.0868 7.18762 17.7396C6.09914 17.6348 5.08576 17.1414 4.33521 16.3508C3.778 15.671 3.48224 14.8164 3.50083 13.9397Z",
    stroke: "#242121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55469 20.8516C10.054 21.4782 10.7871 21.8838 11.592 21.9785C12.3968 22.0732 13.2069 21.8493 13.843 21.3562C14.0387 21.2103 14.2147 21.0408 14.3669 20.8516",
    stroke: "#242121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.28eae20d291dedbe1632c1045b344020.svg";
export { ForwardRef as ReactComponent };